module.exports = __webpack_public_path__ + "fonts/CaslonUniverselle-Italic.b837031a.otf";